import { useEffect, useRef } from 'react';

export const LanguageSwitcher = () => {
  const initialized = useRef(false);

  useEffect(() => {
    const init = () => {
      if (window.google?.translate?.TranslateElement && !initialized.current) {
        initialized.current = true;
        new window.google.translate.TranslateElement(
          { pageLanguage: 'en', autoDisplay: false },
          'gt_widget'
        );
      }
    };
    init();
    window.addEventListener('gt-ready', init);
    return () => window.removeEventListener('gt-ready', init);
  }, []);

  return <div id="gt_widget" data-testid="language-switcher" className="notranslate" translate="no" />;
};
